import { render, staticRenderFns } from "./UploadTeacherQuestionAnswerBoxStudent.vue?vue&type=template&id=638be7ab&"
import script from "./UploadTeacherQuestionAnswerBoxStudent.vue?vue&type=script&lang=js&"
export * from "./UploadTeacherQuestionAnswerBoxStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports